import { useFormikContext } from "formik";
import React from "react";

import IconButton from "../../../components/IconButton";
import Question from "../../../components/Question";
import QuestionDatepicker from "../../../components/QuestionDatepicker";
import RadioGroup from "../../../components/RadioGroup";
import { FlatApplciationType } from "../../../types";

type Props = {
  personIndex: number;
  personId: string;
  addPerson: () => void;
  removePerson: (personId: string) => void;
};

const Person: React.FC<Props> = ({
  personIndex,
  personId,
  addPerson,
  removePerson,
}) => {
  const { errors, values } = useFormikContext<FlatApplciationType>();
  return (
    <>
      <h4
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {`Protected person ${personIndex + 1}`}
        {personIndex !== 0 && (
          <IconButton
            label="Remove"
            icon="plus"
            rotateIcon
            alert
            onClick={(e) => {
              e.preventDefault();
              removePerson(personId);
            }}
          />
        )}
      </h4>
      <Question name={`protected_persons[${personIndex}].prp_giv_nam`} />
      <Question name={`protected_persons[${personIndex}].prp_fam_nam`} />
      <QuestionDatepicker name={`protected_persons[${personIndex}].prp_dob2`} label="Date of birth*" />
      <RadioGroup
        name={`protected_persons[${personIndex}].prp_sex`}
        optionChildren={{
          U: <Question name={`protected_persons[${personIndex}].prp_sex_other`} />,
        }}
      />
      <RadioGroup
        name={`protected_persons[${personIndex}].seeking_appl_role`}
      />
      <RadioGroup name={`protected_persons[${personIndex}].seeking_appl_sub_role`} />
      {personIndex < 5 && values.protected_persons && values.protected_persons.length - 1 === personIndex && (
        <div>
          <IconButton
            disabled={!!errors.protected_persons}
            onClick={(e) => {
              e.preventDefault();
              addPerson();
            }}
            icon="plus"
            label="Add another protected person's details"
          />
        </div>
      )}
    </>
  );
};

export default Person;
